module.exports = __webpack_public_path__ + "static/media/InsureComp-0.27f4d016.jpg";